import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

export default class TimeSlot extends Component {
  static propTypes = {
    isNow: PropTypes.bool,
    showLabel: PropTypes.bool,
    content: PropTypes.string,
  }

  static defaultProps = {
    isNow: false,
    showLabel: false,
    content: '',
  }

  render() {
    return (
      <div
        className={cn(
          'rbc-time-slot',
          this.props.showLabel && 'rbc-label',
          this.props.isNow && 'rbc-now'
        )}
      >
        {this.props.showLabel &&
        <span>{this.props.content}</span>
      }
      </div>
    );
  }
}
